import { UserCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { CardSkeleton } from './CardSkeleton';

interface ActiveUsersCardProps {
  activeUsers: number;
  changeText: string;
  isLoading?: boolean;
}

export const ActiveUsersCard: React.FC<ActiveUsersCardProps> = ({ activeUsers, changeText, isLoading }) => {
  const { t } = useTranslation('dashboard');

  if (isLoading) {
    return <CardSkeleton />;
  }

  return (
    <div className="bg-card p-6 rounded-lg border shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium">{t('cards.activeUsers.title')}</h3>
        <UserCheck className="w-5 h-5 text-muted-foreground" />
      </div>
      <div className="text-2xl font-bold mb-2">{activeUsers}</div>
      <div className="text-sm text-muted-foreground">{changeText}</div>
    </div>
  );
};
